import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const dot: SxStyle = {
  position: 'absolute',
  top: 8,
  left: -10,
};

export const descriptionWrap: SxStyle = {
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
};
